import React, { useEffect, useState } from "react"
import showpasswordlogo from "../../../assets/images/lystfacelogos/showpassword.svg"
import hidepasswordlogo from "../../../assets/images/lystfacelogos/hidepassword.svg"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { ResendRegisterUser, loginUser, resetLoginResponseMsg, resetRegisterResponseMsg, setSessionTimeOut } from "../../../store/actions"
import PropTypes from "prop-types"
import { Card, CardBody, Label, Input, FormFeedback, Form, } from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "../../Common/withRouter"
import { Link, useNavigate } from "react-router-dom"
import form_input_patterns from "../../../constants/form_input_patterns"
import SmallLoader from "../../Common/SmallLoader"
import { appConstants } from "../../../constants/app_constants"
import form_messages from "../../../constants/form_messages"
import { CustomToast, ToastContainer } from "../Common/CustomToast"
import { toast } from 'react-toastify';
import Secure from "../../../constants/secure/Secure"
import CustomPopup from "../../Common/CustomPopup"

//Import Breadcrumb
const LoginForm = props => {
  const dispatch = useDispatch()
  const [isShowPassword, setIsShowPassword] = useState(false);
  const LoginUserState = state => state.Login
  const LoginUserProperties = createSelector(LoginUserState, LoginUser => ({
    loading: LoginUser.loading,
    loginErrorMessage: LoginUser.loginErrorMessage,
    loginError: LoginUser.loginError,
    loginErrorType: LoginUser.loginErrorType,
    sessionTimeout: LoginUser.timeout

  }))
  const { loginErrorMessage, loginError, loading, loginErrorType, sessionTimeout } = useSelector(LoginUserProperties)
  const UserState = useSelector(state => state.Account)
  const { registrationErrorMessage, registrationError, loading: resendLoading } = UserState
  const navigate = useNavigate();
  const [resend, setResend] = useState(true)




  const handleClickResendVerifyLink = () => {
    const ResendSignupVerification = {
      email: validationType.values.email,
    }
    dispatch(ResendRegisterUser(ResendSignupVerification, "login-unverfied"))
  }

  useEffect(() => {
    if (loginErrorMessage !== null || registrationErrorMessage !== null) {
      CustomToast({
        message: loginErrorMessage ? loginErrorMessage : registrationErrorMessage,
        status: loginError || registrationError ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(resetLoginResponseMsg())
      dispatch(resetRegisterResponseMsg())
      if (registrationErrorMessage !== null && !registrationError) {
        navigate('/login')
      }
    }

  }, [loginError, loginErrorMessage, registrationErrorMessage, registrationError, resendLoading])



  const validationType = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      pwd: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .test("email", form_messages.Signup.email.Invalid, function (value) {
          let emailRegex
          if (process.env.REACT_APP_NODE !== "prod") {
            emailRegex = form_input_patterns.TESTING_EMAIL

          }
          else {
            emailRegex = form_input_patterns.EMAIL

          }
          return emailRegex.test(value)
        })
        .max(255)
        .required(form_messages.Signup.businessemail.Required),
      pwd: Yup.string().required(form_messages.Signup.password.Required),
    }),
    onSubmit: values => {
      const LoginData = {
        email: values.email,
        pwd: Secure.Encrypt(values.pwd),
      }
      // props.setLoginSubmitted(true)
      dispatch(loginUser(LoginData, props.router.navigate))
    },
  })



  const onSubmitForm = (e) => {
    e.preventDefault()
    validationType.handleSubmit()
    return false
  }

  const handleSetPassword = (e) => {
    setIsShowPassword(!isShowPassword)
  }

  const handleClickPrimaryButton = () => {
    setPopupDetails({ open: false })
    dispatch(setSessionTimeOut())
  }


  const [popupDetails, setPopupDetails] = useState({
    open: true, titleText: 'Session Expired',
    bodyText: <div><p>Your session expired, please login again to continue.</p></div>,
    primaryButtonText: 'Ok', handleClickPrimaryButton: handleClickPrimaryButton
  })
  return (
    <React.Fragment>
      <div className="auth-form-container">
        <Card>
          <CardBody>
            <Form
              onSubmit={(e) => onSubmitForm(e)}
              className="custom-validation"
            >
              <div className="title">
                {`Login`}
              </div>
              <div className="form-fields-container">
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Business email<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="email"
                    className={`form-input ${validationType.touched.email && validationType.errors.email
                      ? `border-danger`
                      : ``
                      }`}
                    formNoValidate={true}
                    type="text"
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.email?.trimStart() || ""}
                  />
                  {validationType.touched.email && validationType.errors.email ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.email}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className={`form-password-container ${validationType.touched.pwd && validationType.errors.pwd
                  ? ``
                  : `conditional-margin`
                  }`}>
                  <Label className="form-input-title">
                    Password<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="pwd"
                    className={`form-input password-input ${validationType.touched.pwd && validationType.errors.pwd
                      ? `border-danger`
                      : ``
                      }`}
                    formNoValidate
                    type={isShowPassword ? `text` : "password"}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.pwd?.trimStart() || ""}
                  />
                  <span onClick={handleSetPassword} className="password-icon">
                    <img src={!isShowPassword ? hidepasswordlogo : showpasswordlogo} />
                  </span>

                </div>
                <div className="conditional-margin">
                  {validationType.touched.pwd && validationType.errors.pwd ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.pwd}
                    </FormFeedback>
                  ) : null}
                </div>


                <Link
                  to="/forgot-password"
                >
                  <div
                    className="forgot-password"
                  >
                    Forgot password?
                  </div>
                </Link>
              </div>

              <button
                className="background-button"
                disabled={loading}
              > {loading ? <SmallLoader /> : "Login"}</button>
              {
                loginErrorType === "email_not_verfied" &&
                <div className="sub-text2">
                  <div>Didn’t received a code? </div>
                  {resendLoading ? (
                    <div className="ms-1">
                      <SmallLoader />
                    </div>
                  ) : (
                    resend ?
                      <div
                        className="click-resend link"
                        onClick={handleClickResendVerifyLink}
                      >
                        Resend code
                      </div>
                      :
                      <div
                        className="click-resend"
                      >
                        Resend in 30sec
                      </div>
                  )}
                </div>
              }
            </Form>
          </CardBody>
        </Card>
        {(popupDetails.open && sessionTimeout) &&
          <CustomPopup
            popupDetails={popupDetails}
          />
        }
      </div>
    </React.Fragment >
  )
}

export default withRouter(LoginForm)
LoginForm.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
